import * as SvelteImporter from '../src/svelteImporter.js'
import * as CustomSvelteImporter from '../src/traveller/svelteImporter.js'

SvelteImporter.createEventListeners('traveller', CustomSvelteImporter.customRequire)

